<template>
	<component :is="component" />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from '@/utils/vue-api';

const route = useRoute();
const component = ref(null);
const setupDemo = () => {
	const directory = route.params.directory;
	try {
		component.value = () => import(`@rebuild/components/${directory}/Demo.vue`);
	} catch (error) {
		console.error(error);
	}
};

onMounted(() => {
	setupDemo();
});
</script>
